import apiService from "../../Services/APIService";
import { s360ConfigService } from "../../Services/S360Config";
import Cookies from "js-cookie";
export async function findFirstActiveObject(data) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return null;
  }

  const latestWorkitemInHistory = data[0];
  const validationsForInactiveWorkitems = ["terminated", "dispositioned"];

  try {
    const workitemId = latestWorkitemInHistory?.workitemId;
    if (!workitemId) {
      s360ConfigService.activeConversation = false;
      return null;
    }
    const res = await apiService.getChatStaleStatus(workitemId);

    let result = res.data;
    if (result && validationsForInactiveWorkitems.includes(result.state)) {
      s360ConfigService.activeConversation = false;
      return null;
    } else {
      s360ConfigService.activeConversation = result.workitemId;
      s360ConfigService.activeConversationTicketId =
        latestWorkitemInHistory.ticketId;
      return result.workitemId;
    }
  } catch (err) {
    s360ConfigService.activeConversation = false;
    return null;
  }
}

//move setCookieForContactDetails to ConversationUtils.js
export const setCookieForPrimaryIdentification = (data, widgetconfigId) => {
  const cookieName = `nextiva-identification-${widgetconfigId}`;

  Cookies.set(cookieName, data, {
    expires: 30,
    secure: true,
    sameSite: "None",
  });

  // const cookieName = `primaryIdentification_${widgetconfigId}`;
  // document.cookie = `${cookieName}=${JSON.stringify(data)}; path=/; secure;`;
  // const expiryDate = new Date();
  // expiryDate.setMonth(expiryDate.getMonth() + 1);
  // document.cookie = `${cookieName}; expires=${expiryDate.toUTCString()}; path=/; secure;`;
  // sessionStorage.setItem(cookieName, data);
};

export const getCookieForContactDetails = (widgetconfigId) => {
  const cookieName = `nextiva-identification-${widgetconfigId}`;
  // const cookieValue = document.cookie
  //   .split("; ")
  //   .find((row) => row.startsWith(`${cookieName}=`))
  //   ?.split("=")[1];
  // return cookieValue && cookieValue !== undefined
  //   ? JSON.parse(cookieValue)
  //   : null;
  const retrivedCookiee = Cookies.get(cookieName);

  return retrivedCookiee;
};

export const debounce = (callback, delay = 100) => {
  let timeout = null;
  return function (...args) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      timeout = null;
      callback(...args);
    }, delay);
  };
};

export const removeCookieForContactDetails = (widgetconfigId) => {
  sessionStorage.removeItem("userContext");
  localStorage.removeItem("FAQ_Article_Clicked");
  const cookieName = `nextiva-identification-${widgetconfigId}`;
  // const cookieNameTerms = `nextiva-widget-terms-acceptance-${widgetconfigId}`;
  // Cookies.remove(cookieNameTerms, {
  //   secure: true,
  //   sameSite: "None",
  // });
  Cookies.remove(cookieName, {
    secure: true,
    sameSite: "None",
  });
  // document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure;`;
  // sessionStorage.removeItem(cookieName);
};


export function analyzeMessages(messagesList) {

  if (!Array.isArray(messagesList) || messagesList.length === 0) {
    return { isBotEnabled: false, isAiBot: false, hasImageAttached: false };
  }

  let isBotEnabled = false;
  let isAiBot = false;
  let hasImageAttached = false;

  const firstMsg = messagesList[0];
  if (firstMsg?.message) {
    try {
      const parsed = JSON.parse(firstMsg.message);
      if (firstMsg.userType === "BOT") {
        isBotEnabled = true;
      }
      if (firstMsg.userType === "BOT" && parsed?.isAiEnabled === true) {
        isAiBot = true;
      }
    } catch (e) {
    }
  }

  for (const msg of messagesList) {
    if (msg.message) {
      try {
        const parsed = JSON.parse(msg.message);
        if (parsed?.components?.some(c => c.type === "file" && c.attachmentType === "IMAGE")) {
          hasImageAttached = true;
          break;
        }
      } catch (e) {}
    }

    if (Array.isArray(msg.attachments)) {
      if (msg.attachments.some(a => a.mediaType === "IMAGE")) {
        hasImageAttached = true;
        break;
      }
    }

    if (msg.messageMediaType === "IMAGE") {
      hasImageAttached = true;
      break;
    }
  }

  return { isBotEnabled, isAiBot, hasImageAttached };
}
